import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import PageHeader from '../components/PageHeader'
import BioPopup from '../components/BioPopup'
import { ArrowLongRightIcon } from '@heroicons/react/24/outline'

// Import team member images
import profAmazigoImg from '../assets/TEAM MEMBERS/Prof Uche Amazigo FAS.avif'
import profEneObongImg from '../assets/TEAM MEMBERS/Professor H. Ene-Obong FAS.avif'
import barristerOnuboguImg from '../assets/TEAM MEMBERS/Barrister C. Onubogu.avif'
import onyekaOnwenuImg from '../assets/TEAM MEMBERS/Onyeka Onwenu (MFR).avif'
import drNjepuomeImg from '../assets/TEAM MEMBERS/Dr. Ngozi Njepuome.avif'
import profEkwunifeImg from '../assets/EKWUNIFE/Prof Ekwunife.png'
import mrsAmarachiImg from '../assets/TEAM MEMBERS/Mrs Amarachi.avif'
import profCrumpImg from '../assets/TEAM MEMBERS/Professor Andy Crump.avif'
import profOnyegegbuImg from '../assets/TEAM MEMBERS/Professor Nkadi Onyegegbu.avif'
import profOkeibunorImg from '../assets/TEAM MEMBERS/Professor Joseph Okeibunor.avif'
import drEgbucheImg from '../assets/EKWUNIFE/Dr. Chukwudi Michael Egbuche.jpg'
import drAsiegbuImg from '../assets/EKWUNIFE/Prof. Emmanuel Chidubem Asiegbu.png'
import obiakorImg from '../assets/EKWUNIFE/OBIAKOR UGOCHUKWU ANTHONY.jpg'

// Import history image
import historyImage from '../assets/images/MOVING IMPACT IMAGES/_Z4A9857.jpg'

const team = {
  boardOfTrustees: [
    {
      name: 'Prof Uche Amazigo FAS',
      role: 'Chair, BOT',
      image: profAmazigoImg,
      bio: 'Professor Uche Amazigo is the founder/CEO of PACIEH. She is retired Director of the World Health Organization African Programme for Onchocerciasis (River blindness) and one of the few Africans to have led a specialized UN Agency. A Takemi Fellow at Harvard School of Public Health (USA), she has devoted her career to research, sustainable community-driven health interventions, and elimination of neglected tropical diseases. In 2012, she won the prestigious Prince Mahidol Laureate in Public Health.',
    },
    {
      name: 'Professor H. Ene-Obong FAS',
      role: 'Board Member',
      image: profEneObongImg,
      bio: 'Prof. Henriette Ene-Obong is a Professor of Human Nutrition and Head, Department of Human Nutrition and Dietetics, Faculty of Basic Medical Sciences, University of Calabar, Cross River State in Nigeria.',
    },
    {
      name: 'Barrister C. Onubogu',
      role: 'Board Member',
      image: barristerOnuboguImg,
      bio: 'Legal Advisor and Board Member',
    },
    {
      name: 'Onyeka Onwenu (MFR)',
      role: 'Board Member (Late)',
      image: onyekaOnwenuImg,
      bio: 'Nigerian Singer-songwriter and Actress. She served on the Board of PACIEH with passion for the poor and vulnerable populations in Nigeria and West Africa. A well-known human rights and social activist and Journalist. She died on 30th July 2024.',
    },
    {
      name: 'Dr. Ngozi Njepuome',
      role: 'Board Member',
      image: drNjepuomeImg,
      bio: 'Dr. Ngozi Njepuome is a consultant physician of over 40 years, a seasoned Public Health Specialist and an International Health Consultant. She occupied leadership positions at FMOH.',
    },
  ],
  leadership: [
    {
      name: 'Professor Angela Ekwunife',
      role: 'Chief Executive Officer (CEO)',
      image: profEkwunifeImg,
      bio: 'Professor Chinyelu Angela Ekwunife is the Chief Executive Officer of PACIEH and a distinguished Professor of Public Health, Parasitology, and Epidemiology at Nnamdi Azikiwe University. With over two decades of experience, she has significantly contributed to eradicating urogenital schistosomiasis, a success documented in "Under the Big Tree." Professor Ekwunife holds influential leadership roles, serving as the first female Associate Provost (Sciences) at her university, National Treasurer and Fellow of the Parasitology and Public Health Society of Nigeria, Management Board member of the African Research Network for Neglected Tropical Diseases, and a key WHO Social Innovation in Health Initiative Research Team member.',
    },
    {
      name: 'Mrs Amarachi',
      role: 'Assistant Admin Officer',
      image: mrsAmarachiImg,
      bio: 'Assistant Administrative Officer of PACIEH',
    },
  ],
  technicalAdvisory: [
    {
      name: 'Professor Andy Crump',
      role: 'Technical Advisory Committee',
      image: profCrumpImg,
      bio: 'Member of Technical Advisory Committee',
    },
    {
      name: 'Professor H. Ene-Obong',
      role: 'Technical Advisory Committee',
      image: profEneObongImg,
      bio: 'Member of Technical Advisory Committee',
    },
    {
      name: 'Professor Nkadi Onyegegbu',
      role: 'Technical Advisory Committee',
      image: profOnyegegbuImg,
      bio: 'Member of Technical Advisory Committee',
    },
    {
      name: 'Professor Joseph Okeibunor',
      role: 'Technical Advisory Committee',
      image: profOkeibunorImg,
      bio: 'Member of Technical Advisory Committee',
    },
    {
      name: 'Professor Angela Ekwunife',
      role: 'Technical Advisory Committee',
      image: profEkwunifeImg,
      bio: 'Member of Technical Advisory Committee',
    },
    {
      name: 'Dr. Chukwudi Michael Egbuche',
      role: 'Technical Advisory Committee',
      image: drEgbucheImg,
      bio: 'Dr. Chukwudi Michael Egbuche is an Associate Professor and Head of the Department of Parasitology and Entomology at Nnamdi Azikiwe University, Nigeria. He has a significant background in public health initiatives across Nigeria, including leading the first Lymphatic Filariasis Assessment Survey in 2022 and serving as an NTD Coordinator. His experience also encompasses monitoring deworming campaigns, conducting research on Ivermectin\'s benefits, and acting as a WHO Independent Monitor for immunization programs. Dr. Egbuche has also contributed to mapping disease vectors like Simulium damnosum.',
    },
    {
      name: 'Dr. Emmanuel Asiegbu',
      role: 'Technical Advisory Committee',
      image: drAsiegbuImg,
      bio: 'Professor Emmanuel Chidubem Asiegbu is a distinguished scholar from Anambra State, Nigeria, specializing in Educational Planning and the Economics of Education. He has been teaching at Nnamdi Azikiwe University, Awka, since 2010. His research encompasses gender issues, conflict resolution, entrepreneurship, education finance, and quality assurance. Administratively, he serves as Sub-Dean of the Faculty of Education and holds several other significant positions within the university and professional organizations.',
    },
    {
      name: 'OBIAKOR UGOCHUKWU ANTHONY',
      role: 'Technical Advisory Committee',
      image: obiakorImg,
      bio: 'A Researcher and Lecturer in the Department of Parasitology and Entomology, Nnamdi Azikiwe University Awka Anambra state',
    },
  ],
}

function About() {
  const [selectedMember, setSelectedMember] = useState(null)
  const [isBioOpen, setIsBioOpen] = useState(false)

  const handleOpenBio = (member) => {
    setSelectedMember(member)
    setIsBioOpen(true)
  }

  const handleCloseBio = () => {
    setIsBioOpen(false)
    setSelectedMember(null)
  }

  return (
    <>
      <Helmet>
        <title>About Us | PACIEH</title>
        <meta name="description" content="Learn about PACIEH's mission, history, and the dedicated team working to improve education and healthcare access across Africa." />
      </Helmet>

      <PageHeader
        title="About PACIEH"
        subtitle="Dedicated to creating lasting positive change in African communities through education and healthcare initiatives."
      />

      {/* History Section */}
      <section className="py-24 bg-white">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-center"
          >
            <div>
              <h2 className="text-3xl font-bold tracking-tight text-pacieh-blue sm:text-4xl mb-6">
                Our History
              </h2>
              <div className="space-y-6 text-lg text-gray-600">
                <p>
                  Founded in 2010 by Professor Uche Veronica Amazigo, PACIEH emerged from a vision to address the critical challenges facing African communities in education and healthcare access.
                </p>
                <p>
                  What began as a small community initiative has grown into a comprehensive program that has impacted thousands of lives across multiple African countries.
                </p>
                <p>
                  Through strategic partnerships and community-driven approaches, we've established sustainable programs that continue to create positive change.
                </p>
              </div>
            </div>
            <div className="relative h-[400px] overflow-hidden rounded-lg shadow-xl">
              <img
                src={historyImage}
                alt="PACIEH's journey through the years"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-24 bg-pacieh-blue text-white">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-6">
              Our Vision
            </h2>
            <p className="text-xl leading-8 text-gray-300">
              We envision a future where every African community has access to quality education and healthcare, empowering generations to come and fostering sustainable development across the continent.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-24 bg-slate-50">
        <div className="container">
          <div className="max-w-2xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-bold tracking-tight text-pacieh-blue sm:text-4xl">
              Our Leadership & Governance
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Meet the distinguished public health pioneers, educators, and community leaders guiding PACIEH.
            </p>
          </div>

          {/* Board of Trustees */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-pacieh-blue text-center mb-8">Board of Trustees</h3>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
              {team.boardOfTrustees.map((member, index) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.08 }}
                  className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md hover:border-pacieh-green/40 transition-all flex flex-col items-center text-center justify-between"
                >
                  <div className="flex flex-col items-center">
                    <div className="relative h-32 w-32 rounded-full overflow-hidden mb-4 bg-gray-100 border-2 border-pacieh-green/20 shadow">
                      <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
                    </div>
                    <h4 className="text-lg font-bold text-pacieh-blue">{member.name}</h4>
                    <p className="text-xs font-semibold text-pacieh-green mt-0.5">{member.role}</p>
                    {member.bio && (
                      <p className="mt-3 text-xs text-gray-600 line-clamp-3 leading-relaxed">
                        {member.bio}
                      </p>
                    )}
                  </div>
                  {member.bio && (
                    <button
                      type="button"
                      onClick={() => handleOpenBio(member)}
                      className="mt-4 text-xs font-bold text-pacieh-blue hover:text-pacieh-green transition-colors"
                    >
                      Read Full Bio →
                    </button>
                  )}
                </motion.div>
              ))}
            </div>
          </div>

          {/* Leadership Banner Linking to /team */}
          <div className="text-center bg-white rounded-2xl p-8 border border-gray-200 shadow-sm max-w-3xl mx-auto">
            <h3 className="text-xl font-bold text-pacieh-blue mb-2">
              Explore Our Full Team & Advisory Committees
            </h3>
            <p className="text-sm text-gray-600 mb-6">
              View our complete directory of Technical Advisory Committee members, operational staff, and researchers.
            </p>
            <Link
              to="/team"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-pacieh-blue text-white font-semibold text-sm hover:bg-pacieh-green transition-all shadow-sm"
            >
              View Full Team Directory
              <ArrowLongRightIcon className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Bio Modal */}
      <BioPopup
        isOpen={isBioOpen}
        onClose={handleCloseBio}
        member={selectedMember}
      />
    </>
  )
}

export default About 